import request from '@/middleware/request'

const getGrammar = () => {
  return request({
    url: '/grammars/list',
    method: 'get'
  })
}

const createGrammar = data => {
  return request({
    url: '/grammars',
    method: 'post',
    data
  })
}

const updateGrammar = (id, data) => {
  return request({
    url: `/grammars/${id}`,
    method: 'patch',
    data
  })
}

const deleteGrammar = id => {
  return request({
    url: `/grammars/${id}`,
    method: 'delete'
  })
}

export default {
  getGrammar,
  createGrammar,
  updateGrammar,
  deleteGrammar
}
